export default __webpack_public_path__ + "static/media/GNB.ded9bc51.svg";